import type { IReport } from "@mctypes/report.types";
import type { PostProjectByProjectIdReportboardsAndReportIdFieldApiResponse as DirectReportResult } from "../../../../openapi";

export const getDirectReportData = (board: IReport.IReportBoardPopulated) => board.data;

export const applyDirectReportResult = (board: IReport.IReportBoardPopulated, result: DirectReportResult) => {
  board.data = structuredClone(result.data);
  board.revision = result.revision;
  board.updatedAt = result.updatedAt;
  board.lastSavedAt = result.updatedAt;
};
